import { Box, Stack, Typography } from "@mui/material";
import { boxStyle, dataGridStyle } from "../../../../theme";
import { BarChart } from "@mui/x-charts";
import { useEffect, useState } from "react";
import { DataGridPro } from "@mui/x-data-grid-pro";
import dayjs from "dayjs";

const System = ({events = [], setEvents, ransomware = [], setRansomware}) => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const data = [];
    data.push({ label: "Events", number: events.length });
    data.push({ label: "Ransomware", number: ransomware.length });
    setChartData(data);
  }, [events, ransomware]);

  return (
    <Stack direction={"column"} spacing={2}>
      <Typography sx={{fontSize: 25, textAlign: "center"}}>System Data</Typography>
      <Box sx={boxStyle}>
        <BarChart
          dataset={chartData}
          yAxis={[{scaleType: "band", dataKey: "label"}]}
          series={[{id: "number", label: "Number", dataKey: "number"}]}
          height={200}
          layout="horizontal"
        />
      </Box>
      <Box height={"50vh"}>
        <DataGridPro
          sx={dataGridStyle}
          rows={[...events, ...ransomware] || []}
          columns={columns}
          getRowId={(row) => row._id}
        />
      </Box>
    </Stack>
  )
};

export default System;

const columns = [
  {
    field: "timestamp",
    headerName: "TIMESTAMP",
    width: 150,
    renderCell: (params) => dayjs(params.value).format("YYYY-MM-DD HH:mm")
  },
  {
    field: "machineName",
    headerName: "MACHINE NAME",
    width: 150
  },
  {
    field: "eventType",
    headerName: "EVENT TYPE",
    width: 150
  },
  {
    field: "message",
    headerName: "MESSAGE",
    width: 150,
    flex: 1
  }
]